module.exports = {
  siteTitle: 'Sadiq Ahmed | Software Developer | Backend Developer',
  siteDescription:
    'Backend Architect | Node.js | Laravel | Go | Building innovative sites: Portfolios, Stores, & More | Let\'s innovate!',
  siteKeywords:
    'Sadiq, Software Developer, Javascript Developer, Laravel Developer',
  siteUrl: 'https://sadiq.is-a.dev',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'G-5TR19FVXDZ',
  googleVerification: '',
  name: 'Sadiq Ahmed',
  location: 'Bangladesh',
  email: 'connect@sadiq.is-a.dev',
  github: 'https://github.com/sadiq-bd',
  twitterHandle: 'https://twitter.com/sadiq_bd',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/sadiq-bd',
    },
    // {
    //   name: 'Linkedin',
    //   url: 'https://www.linkedin.com/in/sadiq-bd',
    // },
    {
      name: 'Codepen',
      url: 'https://codepen.io/sadiq-bd',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/sadiq_bd',
    },
    {
      name: 'Telegram',
      url: 'https://t.me/sadiqbdbot',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#141414',
    darkNavy: '#000000',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
